import { render, staticRenderFns } from "./LoadingOverlay.ts.vue?vue&type=template&id=1c2491a8"
import script from "./LoadingOverlay.ts.vue?vue&type=script&lang=ts"
export * from "./LoadingOverlay.ts.vue?vue&type=script&lang=ts"
import style0 from "./LoadingOverlay.ts.vue?vue&type=style&index=0&id=1c2491a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports